import { VFC, useState, useEffect } from 'react';

import { useCollectors } from '@/apis/aniftyBackend/users/getCollectors';
import { User } from '@/apis/aniftyBackend/users/interface';

import CollectorBubble from './CollectorBubble';
import styles from './CollectorList.module.scss';
import CollectorModal from './CollectorModal';

type Props = {
  user: User;
};

const CollectorList: VFC<Props> = ({ user }: Props) => {
  const [showCollectorModal, setShowCollectorModal] = useState(false);
  const MAX_ITEM_DISPLAY = 5;

  const { data: collectors } = useCollectors({ creatorId: user.userID });

  const handleCollectorClick = () => {
    setShowCollectorModal(true);
  };

  const handleCloseModal = () => {
    setShowCollectorModal(false);
  };

  // Prevent scrolling when modal is open
  useEffect(() => {
    if (showCollectorModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [showCollectorModal]);

  if (!collectors || collectors.length === 0) {
    return;
  }

  return (
    <>
      <button className={styles.btnLink}>
        <div className={styles.container}>
          {collectors
            .filter((item, index) => index < MAX_ITEM_DISPLAY)
            .map((collector) => {
              return (
                <CollectorBubble key={collector.UserID} collector={collector} />
              );
            })}
        </div>
        <a className={styles.collectorTxt} onClick={handleCollectorClick}>
          {collectors.length} collectors
        </a>
      </button>
      {showCollectorModal && (
        <CollectorModal
          collectors={collectors}
          handleClose={handleCloseModal}
        />
      )}
    </>
  );
};

export default CollectorList;
